'use client';
import { useEffect, useRef, useState } from 'react';

export const AuthorSection = ({ authors }: { authors: string }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [showToggleButton, setShowToggleButton] = useState(false);
  const textRef = useRef<HTMLParagraphElement>(null);

  useEffect(() => {
    // 检查文本是否超出两行
    if (textRef.current) {
      const lineHeight = parseInt(
        window.getComputedStyle(textRef.current).lineHeight,
      );
      const height = textRef.current.scrollHeight;
      setShowToggleButton(height > lineHeight * 2);
    }
  }, [authors]);

  return (
    <div>
      <h3 className="text-sm font-semibold">作者信息</h3>
      <div className="text-sm text-muted-foreground">
        <p ref={textRef} className={isExpanded ? '' : 'line-clamp-2'}>
          {authors}
        </p>
        {showToggleButton && (
          <button
            className="text-primary text-sm mt-1"
            onClick={() => setIsExpanded(!isExpanded)}
          >
            {isExpanded ? '收起' : '展开'}
          </button>
        )}
      </div>
    </div>
  );
};

export const AffiliationSection = ({
  affiliations,
}: {
  affiliations: string[];
}) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const maxLines = 2;
  const shouldCollapse = affiliations.length > maxLines;

  const displayAffiliations = isExpanded
    ? affiliations
    : affiliations.slice(0, maxLines);

  return (
    <div>
      <h3 className="text-sm font-semibold">机构信息</h3>
      <div className="text-sm text-muted-foreground space-y-1">
        {displayAffiliations.map((affiliation, index) => (
          <p key={index}>{affiliation}</p>
        ))}
        {shouldCollapse && (
          <button
            className="text-primary text-sm mt-1"
            onClick={() => setIsExpanded(!isExpanded)}
          >
            {isExpanded ? '收起' : `展开 (${affiliations.length} 个机构)`}
          </button>
        )}
      </div>
    </div>
  );
};
